import { Card } from "@heroui/react"
import classes from "../../styles/NewTeacher.module.scss"
import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { createCategory } from "../../utils/requests/knowladgebase"
import CategoryForm from "../../components/Knowladge/CategoryForm"

const NewCategory = () => {
  const [loading, setLoading] = useState(false)

  const [category, setCategory] = useState<Partial<KnowladgebaseCategory>>({
    type: "teacher",
  })
  const navigate = useNavigate()

  const onSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    const { success } = await createCategory(category)
    setLoading(false)

    if (!success) {
      return
    }

    navigate(-1)
  }

  return (
    <div className={classes.root}>
      <Card className={classes.card}>
        <CategoryForm
          loading={loading}
          onSubmit={onSubmit}
          values={category}
          onChange={setCategory}
          title="קטגוריה חדשה"
          ctaLabel="יצירת קטגוריה חדשה"
        />
      </Card>
    </div>
  )
}

export default NewCategory
